var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"login"},[_c('div',{staticClass:"wrapper d-flex align-items-center"},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-lg-6 mx-auto"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.$auth.isAuthenticated)?_c('button',{on:{"click":_vm.login}},[_vm._v("Log in")]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2b7f32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/AppLogin.vue
// module id = ORtc
// module chunks = 0